import React from 'react';
import ArrowDown from 'assets/icons/arrow-down.svg';

type DropdownProps = {
  selected?: string;
  active: boolean;
  children: React.ReactNode;
  className?: string;
  label?: string;
  placeholder?: string;
  placeholderId?: string;
  onClick: () => void;
  onSelect: (id: string) => () => void;
};

function Dropdown({
  active,
  selected,
  className,
  label,
  placeholder,
  placeholderId,
  children,
  onClick,
  onSelect,
}: DropdownProps) {
  const ulClassName =
    'bg-white rounded-huge border border-skyblue rounded-large w-full';

  const liClassName =
    'flex items-center h-13 justify-between p-2 pl-4 cursor-pointer';

  /**
   * Finds selected option
   * If there is no selected option, it shows a placeholder or the first option
   */
  let selectedChild = undefined;
  let firstChild = undefined;
  let placeholderChild = undefined;

  React.Children.forEach(children, (child, index) => {
    if (React.isValidElement(child)) {
      const {id} = child.props;

      if (id === selected) {
        selectedChild = child;
      }

      if (placeholder && index === 0) {
        placeholderChild = React.cloneElement(child, {
          id: placeholderId,
          children: placeholder,
          className: `${child.props.className || ''} text-eclipse`,
        });
      } else if (index === 0) {
        firstChild = child;
      }
    }
  });

  if (!selectedChild) {
    selectedChild = placeholderChild || firstChild;
  }

  return (
    <div className={className}>
      {label && <p>{label}</p>}
      <div className="relative">
        <ul className={ulClassName}>
          <li className={liClassName} onClick={onClick}>
            {selectedChild}
            <img src={ArrowDown} alt="arrow-down" />
          </li>
        </ul>
        {active && (
          <ul
            className={`${ulClassName} shadow-skyblue-200 absolute top-0 z-10`}
          >
            {placeholderChild && (
              <li
                key={placeholderId}
                className={liClassName}
                onClick={onSelect(placeholderId || '')}
              >
                {placeholderChild}
              </li>
            )}
            {React.Children.map(children, child => {
              if (React.isValidElement(child)) {
                const {id} = child.props;

                return (
                  <li key={id} className={liClassName} onClick={onSelect(id)}>
                    {child}
                  </li>
                );
              }
              return child;
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Dropdown;
